// HomeCoverMessage.js
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { MESSAGE_BADGE_NONE, PREVIEW_PRESET } from '../RemoteConfigKeys.js';
import { MediaAssetFormat } from '../resource/getMediaAsset.js';

import HomeCoverMessage from '../component/HomeCoverMessage.jsx';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getMessageData from '../selector/getMessageData.js';
import getMessageBadges from '../selector/getMessageBadges.js';
import getAssetData from '../selector/getAssetData.js';
import getUserData from '../selector/getUserData.js';
import getMeData from '../selector/getMeData.js';
import { push } from '../action/navigationAction.js';
import sendUnlockMessage from '../action/sendUnlockMessage.js';
import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';
import fetchAssetManifest from '../action/fetchAssetManifest.js';
import fetchUser from '../action/fetchUser.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import {
  SHOWCASE_FEED,
  FLIX_DISPLAY_UNLOCK_COUNT,
} from '../RemoteConfigKeys.js';
import { getKeySystem } from '../resource/getDrmInfo.js';
import getMessageUnlockPrice from '../selector/getMessageUnlockPrice.js';
import getUnlockButtonStatus from '../selector/getUnlockButtonStatus.js';
import getMessageThumbnail from '../selector/getMessageThumbnail.js';

const mapStateToProps = (state, { messageId }) => {
  const likeRatio = getMessageData(
    state,
    messageId,
    'likePercentageWithSignOrDefault'
  );
  const authorId = getMessageData(state, messageId, 'senderId');
  const assetIds = getMessageData(state, messageId, 'assetIds');
  const firstAssetId = assetIds?.[0];
  const unlockPrice = getMessageUnlockPrice(state, messageId);
  const thumbnailSource = getMessageThumbnail(
    state,
    messageId,
    '',
    '1024x1024',
    MediaAssetFormat.JPG,
    'clear'
  );
  const thumbnailSourceBlurred = getMessageThumbnail(
    state,
    messageId,
    '',
    '128x128',
    MediaAssetFormat.JPG,
    'blurred'
  );
  const meUsername = getMeData(state, 'username');

  return {
    assetId: firstAssetId,
    authorId,
    unlockPrice,
    username: getUserData(state, authorId, 'username'),
    originalTitle: getMessageDataWithVariable(
      state,
      messageId,
      'originalTitle',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    originalText: getMessageDataWithVariable(
      state,
      messageId,
      'originalText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    thumbnailSource,
    thumbnailSourceBlurred,
    hasVerified: getRemoteConfigData(state, PREVIEW_PRESET) === 'clear',
    duration: firstAssetId
      ? getAssetData(state, [firstAssetId], 'duration')
      : 0,
    drmRulesetTeststatus: getOperationData(state, ['drm'], 'testStatus'),
    likeRatio,
    unlockTimes: getMessageData(state, messageId, 'unlocksWithDefault'),
    viewTimes: getMessageData(state, messageId, 'viewCountWithDefault'),
    isUnlocked: getMessageData(state, messageId, 'canViewMedia'),
    badges: getMessageBadges(state, messageId),
    unlockButtonStatus: getUnlockButtonStatus(state, messageId),
    isFlix: getMessageData(state, messageId, 'isFlix'),
    isAuthed: !!getMeData(state, 'id'),
    isPro: getMessageData(state, messageId, 'isPro'),
    shouldShowUnlockCount: getRemoteConfigData(
      state,
      FLIX_DISPLAY_UNLOCK_COUNT
    ),
    showcaseFeed: getRemoteConfigData(state, SHOWCASE_FEED),
    messageBadgeNotShowList: getRemoteConfigData(state, MESSAGE_BADGE_NONE),
  };
};

const mapDispatchToProps = (dispatch, { messageId }) => {
  return {
    fetchDrmLicenseAvailability: () =>
      dispatch(
        fetchDrmLicenseAvailability({ messageId, keySystem: getKeySystem() })
      ),
    fetchAssetManifest: ({ messageId, assetId }) =>
      dispatch(fetchAssetManifest({ messageId, assetId })),
    fetchUser: ({ authorId }) => dispatch(fetchUser({ id: authorId })),
    sendUnlockMessage: data => dispatch(sendUnlockMessage(data)),
    push: data => dispatch(push(data)),
    fetchMessageDetail: () => dispatch(fetchMessageDetail({ id: messageId })),
  };
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    // equals to `{ ...ownProps, ...stateProps, ...dispatchProps }`
    // ref: https://github.com/reduxjs/react-redux/blob/v7.1.0/src/connect/mergeProps.js
    null,
    { forwardRef: true } // Required by WithIntersectionObserver
  )(HomeCoverMessage)
);
